import React from 'react';
import { Permanent } from './styled';
export const PermanentContainer = ({ children, className = '', style = null, }) => {
    return (React.createElement(Permanent, { className: `PermanentContainer ${className}`, "data-test": "PermanentContainer-permanent", style }, children));
};
//# sourceMappingURL=index.js.map